// core
import React from 'react';
import { Link } from 'react-router-dom'

// settings + utils
import Settings from 'config.js';
import Auth from 'services/Auth.js';
import API from 'utils/API.js';
import CSV from 'utils/CSV.js';
import XHR from 'components/lib/swell-ui-0.0.3/utils/XHR';

// lib
import Page from 'pages/shared/Page';
import Spinner from 'components/shared/Spinner';

// shared
import PageHeader from 'components/shared/PageHeader';
import ButtonsToolbar from 'components/shared/ButtonsToolbar';
import FiltersToolbar from 'components/shared/filters/FiltersToolbar';
import SortingToolbar from 'components/shared/SortingToolbar';

import MainHeading from 'components/shared/MainHeading';
import PageDataWrapper from 'pages/shared/PageDataWrapper.js';

// page-specific/etc.
import SchoolDetails from 'components/schools/SchoolDetails';

class SchoolViewerPage extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      fetching: true,

      error: '',

      school: null
    };

    this.fetchSchool = this.fetchSchool.bind(this);
  }

  componentDidMount() {
    this.fetchSchool();
  }

  fetchSchool() {
    const SCHOOL_ID = this.props.match.params.schoolId;
    if (!SCHOOL_ID) {
      this.setState({
        error: 'School ID missing'
      });

      return false;
    }

    this.setState({
      school: null,
      fetching: true,
      error: ''
    }, () => {
      API.call('GET', Settings.V3_API_URL + '/schools/' + SCHOOL_ID + '?access_token=' + Auth.getToken(), {}, (response, error) => {
        if (error || !response.data || !response.data.school) {
          this.setState({
            fetching: false,
            error: 'Cannot fetch school' + (error ? ': ' + error.message : ''),

            error: 'Error getting school' + (error ? ': ' + error.message : '')
          });

          return false;
        }

        this.setState({
          fetching: false,
          school: response.data.school
        });
      });
    });
  }

  render() {
    console.log('state', this.state);

    const fetching = this.state.fetching;

    return (
      <div>
        <PageHeader>
          <ButtonsToolbar
            back={{
              label: 'torna all\'overview scuole',
              href: '/schools/overview/'
            }}

            related={
              this.state.school ? [
                {
                  type: 'edit',
                  label: 'Modifica',
                  href: `/schools/${this.state.school.id}/edit/`
                }
              ] : []
            }
          />
          <MainHeading
            icon={this.state.school && !this.state.school.parent_school ? 'fa fa-university' : 'fa fa-school'}
            title={this.state.school ? this.state.school.name : ''}
            descr={this.state.school ? (
              <span style={{fontSize: '150%', color: '#888'}}>{this.state.school.type}</span>
            ) : ''}
          />
        </PageHeader>

        <PageDataWrapper
          appData={this.props.appData}

          data={{
            label: '',
            descr: ''
          }}
          filters={{
            tabs: []
          }}
          search={null}
          status={{
            fetching: fetching,
            errors: null
          }}
        >
          <SchoolDetails school={this.state.school} />
        </PageDataWrapper>
      </div>
    );
  }
}

export default SchoolViewerPage;


// WEBPACK FOOTER //
// ./src/pages/schools/SchoolViewerPage.js